const bodyContainer = document.querySelector(".body-container");
const modal = document.querySelector(".form-modal");
const articleReadButtons = document.querySelectorAll(
  ".landing-slider__article-button"
);
const landingSlider = document.querySelector(".landing-slider");
let swiper;

if (articleReadButtons) {
  articleReadButtons.forEach((it) =>
    it.addEventListener("click", (evt) => {
      evt.preventDefault();
      const articleName = it
        .closest(".landing-slider__slide")
        .querySelector(".landing-slider__title").innerText;
      modal.querySelector(".site-modal__title").innerText = "Доступ к статье";
      modal.querySelector(".site-modal__description").innerText =
        "Чтобы получить доступ, оставьте свои контактные данные";
      modal.querySelector("#type").value = "article";
      modal.querySelector("#hidden_item_name").value = articleName;
      modal.querySelector("#page_link").value = window.location.href;
      modal.querySelector("#form_type").value = "Читать статью";
      modal.classList.add("site-modal--opened");
      bodyContainer.classList.add("body-container--no-scroll");
    })
  );
}

if (landingSlider) {
  swiper = new Swiper(".swiper-container", {
    loop: true,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
